// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oFZWwibsxhQElJ3AGawj {
  display: flex;
  flex-direction: column;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]};
  height: 100%;
}

.BjnqG2Z8mb13HJlxIGRl {
  width: 30%;
  margin: 40px auto 40px auto;
}

.DW1Odndb1BC0etU16rz9 {
  text-align: center;
  font-weight: bold;
}

.CstAWDRq5JyW2rNVnXKR {
  max-width: 1000px;
  margin: auto;
  font-size: 24px;
  text-align: center;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.qktgGnx5Cer3m3mYOMql {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
  margin-bottom: 10px;
}

.sR1bVuBJwynqvggT7AXl {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.UlfP14bFbWlNl6PtmMAo {
  display: inline-block;
  width: 100%;
}

.UlfP14bFbWlNl6PtmMAo .geNs48SPtWmP_liSGf7m {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]};
  width: 5px;
  height: 5px;
  margin: 5px;
}

.UlfP14bFbWlNl6PtmMAo .geNs48SPtWmP_liSGf7m.qqcxBlEPdbthHicaOt_a {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
  width: 5px;
  height: 5px;
  margin: 5px;
}

.LfyNRVmU8A5XYu3Y3cPR {
  font-size: 24px;
  white-space: nowrap;
}

.nOwPG8DKuTYKRkknoYzq {
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/views/DownloadInvoice/Modal/EndModal.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mDAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mDAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mDAAsB;EACtB,8DAAiC;EACjC,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mDAAmB;EACnB,8DAA8B;EAC9B,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-text, color-text-subtle, color-purple, color-purple-bg from colors;\n\n.bodyModal {\n  display: flex;\n  flex-direction: column;\n  color: color-text;\n  height: 100%;\n}\n\n.image {\n  width: 30%;\n  margin: 40px auto 40px auto;\n}\n\n.header {\n  text-align: center;\n  font-weight: bold;\n}\n\n.description {\n  max-width: 1000px;\n  margin: auto;\n  font-size: 24px;\n  text-align: center;\n  color: color-text-subtle;\n}\n\n.footerContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: auto;\n  margin-bottom: 10px;\n}\n\n.flexRowEnd {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.buttonSlider {\n  display: inline-block;\n  width: 100%;\n}\n\n.buttonSlider .checkboxSlider {\n  color: color-purple-bg;\n  background-color: color-purple-bg;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n.buttonSlider .checkboxSlider.checked {\n  color: color-purple;\n  background-color: color-purple;\n  width: 5px;\n  height: 5px;\n  margin: 5px;\n}\n\n.nextStepButton {\n  font-size: 24px;\n  white-space: nowrap;\n}\n\n.video {\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"bodyModal": `oFZWwibsxhQElJ3AGawj`,
	"image": `BjnqG2Z8mb13HJlxIGRl`,
	"header": `DW1Odndb1BC0etU16rz9`,
	"description": `CstAWDRq5JyW2rNVnXKR`,
	"footerContainer": `qktgGnx5Cer3m3mYOMql`,
	"flexRowEnd": `sR1bVuBJwynqvggT7AXl`,
	"buttonSlider": `UlfP14bFbWlNl6PtmMAo`,
	"checkboxSlider": `geNs48SPtWmP_liSGf7m`,
	"checked": `qqcxBlEPdbthHicaOt_a`,
	"nextStepButton": `LfyNRVmU8A5XYu3Y3cPR`,
	"video": `nOwPG8DKuTYKRkknoYzq`
};
export default ___CSS_LOADER_EXPORT___;
